"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 3.01a5 5 0 100 10 5 5 0 100-10z"];
//# sourceMappingURL=symbol-circle.js.map